import {
	QueryClient,
	QueryClientProvider,
	type QueryClientProviderProps
} from '@tanstack/react-query';

type QueryProviderProps = Pick<QueryClientProviderProps, 'children'>;

const queryClient = new QueryClient();

export const QueryProvider = ({ children }: QueryProviderProps) => {
	return (
		<QueryClientProvider client={queryClient}>
			{children}
		</QueryClientProvider>
	);
};
